import Hamburger from "./Hamburger";
import HelpfulLinks from "./HelpfulLinks";
import Icon from "../Icon";
import T from "../translations/Translations";

import "../../styles/Header.scss";

/**
 * This is returning the header content with buttons and links
 * @name Header
 * @return {JSX.Element}
 */
const Header = () => {
    return (
        <nav className="header-container">
            <div className="header-left">
                <div className="header-dcsd-icon">
                    <a
                        aria-label="Douglas County School District Page Link"
                        href="https://www.dcsdk12.org"
                        onClick={() => {
                            sessionStorage.clear();
                            return true;
                        }}
                        rel="noopener noreferrer"
                        style={{
                            textDecoration: "none",
                            color: "black"
                        }}
                        tabIndex={0}
                    >
                        <Icon fill="#19608f" height={55} iconName="DCSD" width={55} />
                    </a>
                </div>
                <div className="tagline-container">
                    <div className="dcsd-tagline1">Douglas County School District</div>
                    <div className="dcsd-tagline2">{T({ key: "Main_Nav_Tagline" })}</div>
                </div>
            </div>
            <div className="header-right">
                <div className="nav-button-container">
                    <HelpfulLinks />
                </div>
                <div className="mobile-hamburger">
                    <Hamburger />
                </div>
            </div>
        </nav>
    );
};

export default Header;
